<section class="auth-container">
  <div class="auth-content">
    <div class="logo-wrapper">
      <a [href]="urlSite" target="_blank">
        <img [src]="urlLogo" class="auth-logo" alt="Chronos Logo" />
      </a>
    </div>
    <div class="p-card auth-card">
      <div class="p-card-body">
        <h2 class="auth-title">{{ title }}</h2>
        <ng-content></ng-content>
      </div>
    </div>
    <div class="auth-footer">
      <span>© 2025</span>
      <div class="auth-footer-links">
        <a href="#" class="p-link">Ajuda</a>
        <a href="#" class="p-link">Termos</a>
        <a href="#" class="p-link">Privacidade</a>
      </div>
    </div>
  </div>
</section>